import { Zero, Logger, Components, Utils } from 'Zero';
import Handlebars from 'Vendor/handlebars/dist/handlebars.js';

const Log = new Logger('Zero/StoreLocator/ZResults');

export default class ZResults extends Components {
  get Messages() {
    return {
      'StoreLocator:Init': this.onStoreLocatorInit,
      'StoreLocator:Pin:Clicked': this.onClickedLightPin,
      'StoreLocator:Pin:Unclicked': this.onUnclickedLightPin,
      'StoreLocator:Pin:Hover': this.onHoverLightPin,
      'StoreLocator:Pin:Unhover': this.onUnhoverLightPin,
      'StoreLocator:List:Clicked': this.onClickedLightPin,
      'StoreLocator:List:Unclicked': this.onUnclickedLightPin,
      'StoreLocator:List:Hover': this.onHoverLightPin,
      'StoreLocator:List:Unhover': this.onUnhoverLightPin,
    };
  }

  get Selectors() {
    return {
      Template: '#template-store',
      ResultsContainer: '#results-list-container',
      StoreListElement: 'li.js-store-item',
      ShowDetailsButton: '.js-show-detail',
      HideDetailsButton: '.js-hide-detail',
      HighlightedClass: 'highlighted',
      SelectedClass: 'selected',
      DetailToggle: '.js-detail-toggle',
      ToggleMoreResults: '.js-more-C-and-C-results'
    };
  }

  constructor(element) {
    super(element);

    this.ResultsEl = this.element.find(this.Selectors.ResultsContainer);
    this.ToggleMoreResults = this.element.find(this.Selectors.ToggleMoreResults)
    this.ResultPanelTrigger = this.element.find(
      this.Selectors.ResultPanelTrigger
    );
    this.TemplateCompile = this.ParsedTemplate;

    this.onLoadStores();
    this.bindEventOnResults();
    this.equalUtil();
    this.ifEquals();

    this.loadedStores = [];
    this.chunkedLoadedStores = [];
  }


  get react() {
    return {
      onLoadStores: function () {
        const inCart = document.body.classList.contains('t-cart');
        var stores = Zero.$state.StoreLocator.Stores;
        this.ResultsEl[0].innerHTML = ''; // faster than jquery
        this.loadedStores = [];
        this.chunkedLoadedStores = [];

        let size = 0;
        if (inCart) {
          if (stores && stores.features) {
            let html = [];
            const maxSize = 3;

            for (var i = 0, store; (store = stores.features[i++]);) {
              if (store.properties.features.hasOwnProperty('CLICK_AND_COLLECT')) {
                this.loadedStores.push(this.TemplateCompile(store.properties));
                size++;
              }
            }

            if ($(window).width() < 768 && this.loadedStores.length < maxSize) {
              this.ToggleMoreResults[0].classList.remove('d-flex');
              this.ToggleMoreResults[0].classList.add('d-none');
            }

            if ($(window).width() < 768 && this.loadedStores.length > maxSize) {
              this.ToggleMoreResults[0].classList.add('d-flex');
              this.ToggleMoreResults[0].classList.remove('d-none');
              this.chunkedLoadedStores = this.loadedStores.slice(0, 3)
              this.ResultsEl[0].innerHTML = this.chunkedLoadedStores.join('');
            } else {
              this.ResultsEl[0].innerHTML = this.loadedStores.join('');
            }
          }
        } else {
          if (stores && stores.features) {
            for (var i = 0, store; (store = stores.features[i++]);) {
              if (!store.properties.storeHidden) {
                this.loadedStores.push(this.TemplateCompile(store.properties));
                size++;
              }
            }
            this.ResultsEl[0].innerHTML = this.loadedStores.join('');
          }
        }

        size > 0 ? this.element.removeClass('is-empty') : this.element.addClass('is-empty');
      },
    };
  }

  get ParsedTemplate() {
    let templateEl = this.element.find(this.Selectors.Template);
    return Handlebars.compile(templateEl[0].innerHTML);
  }

  onStoreLocatorInit(msg) {
    this.StoreLocator = msg.StoreLocator;
  }


  bindEventOnResults() {

    this.ToggleMoreResults.on('click', e => {
      e.preventDefault();
    const $el = $(e.currentTarget);
    this.ResultsEl[0].innerHTML = this.loadedStores.join('');
    $el.removeClass('d-flex');
    $el.addClass('d-none');
  }
  );

    this.ResultsEl.off('mouseenter mouseleave').on(
      'mouseenter',
      this.Selectors.StoreListElement,
      e => {
      if (this.PinHasBeenClicked) {
      return;
    }
    let data = Utils.JsonDa.data(e.currentTarget, this.Name.toLowerCase());
    let marker = this.StoreLocator.getMarker(data.store.key);
    if (marker) {
      this.CAST('StoreLocator:List:Hover', { marker: marker });
    }
  }
  );

    this.ResultsEl.on('mouseleave', this.Selectors.StoreListElement, e => {
      if (this.PinHasBeenClicked) {
      return;
    }
    let data = Utils.JsonDa.data(e.currentTarget, this.Name.toLowerCase());
    let marker = this.StoreLocator.getMarker(data.store.key);
    if (marker) {
      this.CAST('StoreLocator:List:Unhover', { marker: marker });
    }
  });

    //show
    this.ResultsEl.on(
      'click',
      `${this.Selectors.StoreListElement} ${this.Selectors.ShowDetailsButton}`, e => {
      e.preventDefault();
    let $this = this.element.find(e.currentTarget);
    let parentLi = $this.closest(this.Selectors.StoreListElement);
    let data = Utils.JsonDa.data(parentLi, this.Name.toLowerCase());
    let prev_marker_code = this.PrevMarkerCode;
    this.CAST('StoreLocator:Detail:Clicked', { store_id: data.store.id });
    this.CAST('StoreLocator:Detail:onCloseResults');
  }
  );

    // hide
    this.ResultsEl.on(
      'click',
      `${this.Selectors.StoreListElement} ${this.Selectors.HideDetailsButton}`, e => {
      e.preventDefault();
    var $this = this.element.find(e.currentTarget);
    var parentLi = $this.closest(this.Selectors.StoreListElement);
    let data = Utils.JsonDa.data(parentLi, this.Name.toLowerCase());
    let marker = this.StoreLocator.getMarker(data.store.key);

    if (marker) {
      this.CAST('StoreLocator:List:Unclicked', { marker: marker });
    }

    this.PrevMarkerCode = '';
  }
  );
  }

  onClickedLightPin(msg) {
    let marker = msg.marker;
    let code = marker.getKey();
    let storeElement = this.ResultsEl.find(
      `${this.Selectors.StoreListElement}[data-${
        this.Name
        }-store-key='${code}']`
    );

    storeElement.addClass(this.Selectors.SelectedClass);

    ZResults.scrollCard(this, storeElement);

    this.PinHasBeenClicked = true;
    this.PrevMarkerCode = code;
  }

  onUnclickedLightPin(msg) {
    let marker = msg.marker;
    let code = marker.getKey();
    let storeElement = this.ResultsEl.find(
      `${this.Selectors.StoreListElement}[data-${
        this.Name
        }-store-key='${code}']`
    );

    storeElement.removeClass(
      `${this.Selectors.SelectedClass} ${this.Selectors.HighlightedClass}`
    );
    this.PinHasBeenClicked = false;
    this.PrevMarkerCode = null;
  }

  onHoverLightPin(msg) {
    let marker = msg.marker;
    let code = marker.getKey();
    let storeElement = this.ResultsEl.find(
      `${this.Selectors.StoreListElement}[data-${
        this.Name
        }-store-key='${code}']`
    );

    storeElement.addClass(this.Selectors.HighlightedClass);

    if (msg.__msg__ === 'StoreLocator:Pin:Hover') {
      ZResults.scrollCard(this, storeElement);
    }
  }

  static scrollCard(element, storeElement) {
    let elContainer = element.element;
    if($( window ).width() >= 1280) {
      let elContainerOffset = elContainer.offset().top;
      let actScrollTop = elContainer.scrollTop();
      let myElOffset = actScrollTop + storeElement.offset().top - elContainerOffset;
      elContainer.animate({ scrollTop: myElOffset }, 400);
    } else {
      let elContainerOffset = elContainer.position().left;
      let actScrollTop = elContainer.scrollLeft();
      let myElOffset = actScrollTop + storeElement.offset().left - elContainerOffset;
      elContainer.animate({'scrollLeft': myElOffset}, 500);
    }


  }

  onUnhoverLightPin(msg) {
    let marker = msg.marker;
    let code = marker.getKey();
    let storeElement = this.ResultsEl.find(
      `${this.Selectors.StoreListElement}[data-${
        this.Name
        }-store-key='${code}']`
    );

    storeElement.removeClass(this.Selectors.HighlightedClass);
  }

  equalUtil() {
    Handlebars.registerHelper('equal', function(lvalue, rvalue, options) {
      if (arguments.length < 3)
        throw new Error('Handlebars Helper equal needs 2 parameters');
      if (lvalue != rvalue) {
        return options.inverse(this);
      } else {
        return options.fn(this);
      }
    });
  }

  ifEquals() {
    Handlebars.registerHelper('ifEquals', function(a, b, options) {
      if (a === b) {
        return options.fn(this);
      }

      return options.inverse(this);
    });
  }
}

export { ZResults };
